"use strict";

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var nocUtil = require('../../util/noc-util');
var Highcharts = require('highcharts/highstock');
var graphUtil = require('../../util/graph-util');
var moment = require('moment');

module.exports = /*@ngInject*/["$scope", "$translate", "$stateParams", "TripDashboardFactory", "$filter", "AdvancedQueryResourceService", "TripDashboardStatus", "$q", "TimeZoneFactory", "$timeout", "TrainGridFactory", "operators", function TripDashboardSlaController($scope, $translate, $stateParams, TripDashboardFactory, $filter, AdvancedQueryResourceService, TripDashboardStatus, $q, TimeZoneFactory, $timeout, TrainGridFactory, operators) {

    var vm = this;

    var consumptionPerOperatorChart;
    var fairUseExceedPerClassChart;
    var userSpreadPerClassChart;
    var avgConsumptionPerClassChart;
    var dailyTotalUsersChart;
    var portalServiceClasses;
    var spectrumBandUsagePerModemChart;

    vm.statTiles = [];

    //hide all charts that display data about portal service classes
    $scope.hideChartsPerClass = false;
    //hide dashboard tile with portal user count
    $scope.hidePortalUserTile = false;
    //hide tile that shows the % of users that exceeded their data limit
    $scope.hideUserExceedTile = false;
    //hide SLA 16
    $scope.hideBackboneAvailability = false;
    //hide QoE line chart
    $scope.hideQoEChart = false;
    //hide SLA 14
    $scope.hideTrainGroundConnectivity = false;
    //hide pie chart that displays consumption per operator
    $scope.hideConsumptionPerOperatorPieChart = false;
    // hide daily bar chart with user count.
    $scope.hideDailyNumberOfUsersChart = false;
    //array to hold divs that eventually will hold various charts
    $scope.slaCharts = [];
    //toggle to start renedering sla charts
    $scope.renderSlaChart = false;
    //toggle to hide sla train grid, default off.
    $scope.hideTrainGrid = true;
    //toggle to hide sla OBIS, default true.
    $scope.isDashboardHideObis = true;
    //toggle to hide Spectrum Band Usage, default true.
    $scope.hideSpectrumBandUsage = true;

    var colorsPerOperator = new Map();
    var colorsPerClass = new Map();

    var defaultColors = [
        '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000'
    ];

    var thousand24 = 1024;
    var thousand = 1000;

    var credits = {
        credits: {
            enabled: false
        }
    };

    $scope.convertKbitConsumption = function (kbits) {
        var mbits = kbits / thousand;
        var x = convertMbits(mbits);
        return x.value + " " + x.unit;
    };

    $scope.toGigaByte = function (bytes) {
        return nocUtil.roundTo((bytes / (thousand24 * thousand24 * thousand24)), 2);
    };

    $scope.convertConsumption = function (mbits) {
        var x = convertMbits(mbits);
        return x.value + " " + x.unit;
    };

    $scope.toMbits = function (kbits) {
        var mbits = $filter('number')((kbits / thousand), 2);
        return mbits + " Mbit/s"
    };

    $scope.convertThrougput = function (kbits) {
        var x = convertMbits(kbits / thousand);
        return x.value + " " + x.unit + "/s";
    };

    function extractColors(data, map) {
        var colors = {};
        if (operators) {
            data.forEach(function (value, idx) {
                var currentOperator = operators.find(function (operator) {
                    return (operator.network + ' ' + operator.iso.toUpperCase()) === value.dbKey;
                });
                colors[idx] = currentOperator ? currentOperator.color : null;
            });
        }

        data.forEach(function (value, idx) {
            if (!colors[idx]) {
                var reservedColors = Object.keys(colors).filter(function (idxColor) {
                    return !!colors[idxColor];
                }).map(function (idxColor) {
                    return colors[idxColor];
                });
                colors[idx] = getColorPerKey(value.dbKey, map, reservedColors);
            }
        });
        return Object.keys(colors).map(function (idx) {
            return colors[idx];
        });
    }

    function init() {

        $scope.$emit('tripDashboardStatusChange', TripDashboardStatus.SEARCHING_TRIP_DATA);

        var from = nocUtil.toDate($stateParams.from);
        var to = nocUtil.toDate($stateParams.to);
        var query = util.isDefined($stateParams.query) ? $stateParams.query : "";
        var trainIds = $stateParams.trainIds;
        var type = $stateParams.type;

        var tzPeriod = TimeZoneFactory.formatPeriodInCurrentTimezone(from, to);

        vm.searchParams = {
            projectId: $scope.selectedProject.id,
            trainIds: trainIds,
            from: tzPeriod.start,
            to: tzPeriod.end,
            type: type,
            query: query
        };

        AdvancedQueryResourceService.tripsDashboard().get(vm.searchParams).$promise.then(function (data) {

            if (util.isDefined(data) && !arrayUtil.isNotEmptyArray(data.tripIds)) {
                console.warn("No trips found for this criteria");
                $scope.$emit('tripDashboardStatusChange', TripDashboardStatus.NO_TRIP_DATA_FOUND);
                return;
            }

            $scope.$emit('tripDashboardStatusChange', TripDashboardStatus.TRIP_DATA_FOUND);

            getTileData(data.tripIds);
        });
    }

    init();

    function showTrainGrid(tripIds) {
        TrainGridFactory.getTrainGrid(tripIds, function (data) {
            $scope.trains = data;
        });
    }


    function getColorPerKey(operator, map, reservedColors) {
        var unusedColors = reservedColors ? defaultColors.filter(function (color) {
            return !reservedColors.find(function (reservedColor) {
                return reservedColor === color;
            });
        }) : defaultColors;
        return unusedColors[0];
    }

    function createQoEChart(tripIds) {
        var QoECalls = [TripDashboardFactory.getQoEDailyAvgUserThroughput, TripDashboardFactory.getQoEDailyUserThroughputPercentile, TripDashboardFactory.getQoEDailyVuTimePercentile, TripDashboardFactory.getQoEDailyVuTimeAvg, TripDashboardFactory.getQoEDailyAvgLatency];

        var promises = [];

        QoECalls.forEach(function (httpCall) {
            promises.push(httpCall(tripIds));
        });


        $q.all(promises).then(function (results) {
            console.log(results);

            var allData = [];
            results.forEach(function (data) {
                data.data.forEach(function (value) {
                    allData.push(value);
                });
            });

            console.log(allData)

            var dataset = extractDailyDataset(allData, function (entry) {
                return [new Date(entry.timestamp).getTime(), formatQoESqiValue(entry)];
            }, function (entry) {
                return getQoESqiName(entry);
            }, function (category, holder) {
                return category === holder.name;
            }, function (value) {
                return getQoESqiName(value);
            }, true, true);

            console.log(dataset)

            dataset.forEach(function (data) {
                data.yAxis = getQoEAxisNumber(data.key);
                data.color = getQoEAxisColor(data.key);
            });

            console.log(dataset)
            
            new Highcharts.Chart($.extend({
                chart: {
                    renderTo: 'qoe-chart',
                    type: 'line',
                    borderColor: '#ddd',
                    borderWidth: 1,
                    zoomType: 'x'
                },
                colors: Highcharts.getOptions().colors,
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: false
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    valueDecimals: 2
                },
                xAxis: {
                    type: 'datetime',
                    crosshair: true
                },
                yAxis: [{
                    labels: {
                        format: '{value} kbps',
                        style: {
                            color: Highcharts.getOptions().colors[2]
                        }
                    },
                    title: {
                        text: $translate.instant('I18N_DASHBOARD.CHART_DAILY_QOS_AXIS_THROUGHPUT'),
                        style: {
                            color: Highcharts.getOptions().colors[2]
                        }
                    },
                    opposite: true

                }, {
                    gridLineWidth: 0,
                    labels: {
                        format: '{value} s',
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    },
                    title: {
                        text: $translate.instant('I18N_DASHBOARD.CHART_DAILY_QOS_AXIS_DOWNLOAD_TIME'),
                        style: {
                            color: Highcharts.getOptions().colors[0]
                        }
                    }

                }, {
                    gridLineWidth: 0,
                    title: {
                        text: $translate.instant('I18N_DASHBOARD.CHART_DAILY_QOS_AXIS_LATENCY'),
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                    labels: {
                        format: '{value} ms',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                    opposite: true
                }],
                title: {
                    text: $translate.instant('I18N_DASHBOARD.CHART_DAILY_QOS_INDICATORS')
                },
                legend: {
                    labelFormat: '{name}',
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                },
                series: dataset
            }, credits));
        });
    }


    function createSpectrumUsageCharts(tripIds) {
        TripDashboardFactory.getSpectrumBandUsagePerModem(tripIds).then((result) => {

            var xAxisLabels = result && result.data.reduce((acc, item) => {
                const modem = item.dbKey.split('_')[0].replace('-Cell-', 'M');
                if (!acc.find(x => x === modem)) {
                    acc.push(modem)
                }
                return acc;
            }, []);

            var series = result && result.data.reduce((acc, item) => {
                const modem = item.dbKey.split('_')[0].replace('-Cell-', 'M');
                var spectrumBand = item.dbKey.split('_')[1];
                if (!acc[spectrumBand]) {
                    acc[spectrumBand] = xAxisLabels.map(() => null);
                }
                acc[spectrumBand][xAxisLabels.indexOf(modem)] = item.dbValue;
                return acc;
            }, {})

            var dataset = Object.keys(series).map(key => {
                return {
                    name: key,
                    data: series[key]
                }
            });

            spectrumBandUsagePerModemChart = createDashboardColumnChart({
                divId: 'spectrum-band-per-modem-usage-chart',
                title: $translate.instant('I18N_DASHBOARD.CHART_SPECTRUM_BAND_USAGE_PER_MODEM'),
                categories: xAxisLabels,
                isStacked: true,
                showLegend: true,
                tooltip: getToolTip("%"),
                minMax: {
                    min: 0,
                    max: xAxisLabels.length - 1
                }

            });
            graphUtil.extendDataSerie(spectrumBandUsagePerModemChart, dataset, getSingleSeriesDataLabelValue('%'));
            spectrumBandUsagePerModemChart.reflow();
        });

    }
    function createPerOperatorCharts(tripIds) {

        TripDashboardFactory.getConsumptionPerOperator(tripIds).then(function (data) {

            data = data.data;
            $scope.emptyConsumptionPerOperator = true;

            consumptionPerOperatorChart.options.colors = extractColors(data, colorsPerOperator);

            consumptionPerOperatorChart.addSeries($.extend({
                name: 'GB',
                data: convertKeyValueToDataSet(data, function (value) {
                    return nocUtil.roundTo((value / (thousand24 * thousand24 * thousand24)), 2);
                })
            }, getDataLabelPercentageAndValue(' GB')));

            consumptionPerOperatorChart.reflow();

            var totalConsumption = 0;
            data.forEach(function (operatorConsumption) {
                totalConsumption += operatorConsumption.dbValue;
            });

            $scope.dashboard.totalConsumption = totalConsumption;
        });

        TripDashboardFactory.getDailyConsumptionPerOperator(tripIds)
            .then(function (data) {
                data = data.data;
                data = data.sort(function (first, second) {
                    return first.timestamp > second.timestamp ? 1 : -1;
                });
                var dataset = extractDailyDataset(data, function (value) {
                    return nocUtil.roundTo((value.dbValue / (thousand24 * thousand24)), 0);
                });

                console.log(dataset)

                //console.log(JSON.stringify(dataset))

                var categories = Array.from(extractCategories(data));

                var colors = extractColors(data, colorsPerOperator);

                var chart = createDashboardColumnChart({
                    divId: 'daily-consumption-per-operator-chart',
                    title: $translate.instant('I18N_DASHBOARD.CHART_DAILY_CONSUMPTION_PER_OPERATOR'),
                    categories,
                    isStacked: true,
                    showLegend: true,
                    colors,
                    dataset
                });

                //console.log(categories);
                //console.log(dataset)
                //console.log(colors)
                
 //               graphUtil.extendDataSerie(chart, dataset, getSingleSeriesDataLabelValue(''));

                chart.reflow();
            });

        TripDashboardFactory.getDailyConsumptionPercentagePerOperator(tripIds)
            .then(function (data) {

                data = data.data;
                console.log(data)
                var dataset = extractDailyDataset(data, function (value) {
                    return nocUtil.roundTo(value.dbValue * 100, 2);
                });
                console.log(dataset)

                var dailyConsumptionPerOperatorPercentageChart = createDashboardColumnChart({
                    divId: 'daily-consumption-per-operator-percentage-chart',
                    title: $translate.instant('I18N_DASHBOARD.CHART_PERCENT_DAILY_CONSUMPTION_PER_OPERATOR'),
                    categories: Array.from(extractCategories(data)),
                    isStacked: true,
                    showLegend: true,
                    colors: extractColors(data, colorsPerOperator)
                });

                graphUtil.extendDataSerie(dailyConsumptionPerOperatorPercentageChart, dataset, getSingleSeriesDataLabelValue('%'));

                dailyConsumptionPerOperatorPercentageChart.options.colors = extractColors(data, colorsPerOperator);

                dailyConsumptionPerOperatorPercentageChart.reflow();
            });


    }

    function createPerClassCharts(tripIds) {

        TripDashboardFactory.getFairUseExceedPerClass(tripIds).then(function (data) {

            data = data.data;
            //key is class name and not id
            var translated = [];
            data.forEach(function (entry) {
                var key = entry.dbKey;
                if (!graphUtil.isANumber(entry.dbKey)) {
                    key = replaceClassNameById(entry);
                }
                var existing = arrayUtil.getFirstInList(translated, 'dbKey', key);
                if (util.isDefined(existing)) {
                    existing.dbValue += entry.dbValue;
                } else {
                    translated.push({ 'dbKey': key, 'dbValue': entry.dbValue });
                }
            });
            fairUseExceedPerClassChart.options.colors = extractColors(translated, colorsPerClass);

            fairUseExceedPerClassChart.addSeries($.extend({
                name: ' ' + $translate.instant("I18N_DASHBOARD.USERS"),
                data: convertKeyValueToDataSet(translated, null, replaceClassIdWithName)
            }, {
                    dataLabels: {
                        format: '<b>{point.name}</b>: {point.y} ' + $translate.instant("I18N_DASHBOARD.USERS") + '</br>'
                    }
                }));

            fairUseExceedPerClassChart.reflow();
        }
        );

        TripDashboardFactory.getUserSpreadPerClass(tripIds)
            .then(function (data) {

                data = data.data;

                userSpreadPerClassChart.options.colors = extractColors(data, colorsPerClass);

                userSpreadPerClassChart.addSeries($.extend({
                    name: $translate.instant("I18N_DASHBOARD.USERS"),
                    data: convertKeyValueToDataSet(data, null, replaceClassIdWithName)
                }, getDataLabelPercentageAndValue(' ' + $translate.instant("I18N_DASHBOARD.USERS"))));

                userSpreadPerClassChart.reflow();
            }
            );


        TripDashboardFactory.getAvgConsumptionPerClass(tripIds)
            .then(function (data) {

                data = data.data;

                avgConsumptionPerClassChart.options.colors = extractColors(data, colorsPerClass);

                avgConsumptionPerClassChart.addSeries($.extend({
                    name: 'MB',
                    data: convertKeyValueToDataSet(data, function (value) {
                        return nocUtil.toMegaByte(value, thousand24);
                    }, replaceClassIdWithName)
                }, getPointDataLabelValue(' MB')));

                avgConsumptionPerClassChart.reflow();
            });

        TripDashboardFactory.getDailyUserSpreadPerClass(tripIds)
            .then(function (data) {

                data = data.data;
                var dataset = extractDailyDataset(data, undefined, replaceClassIdWithName);

                var dailyNumberOfUsersPerClassChart = createDashboardColumnChart({
                    divId: 'daily-user-spread-per-class-chart',
                    title: $translate.instant('I18N_DASHBOARD.CHART_DAILY_USERS_PER_CLASS'),
                    categories: Array.from(extractCategories(data)),
                    legend: {
                        unitBeforeText: $translate.instant("I18N_DASHBOARD.CLASS") + ' '
                    },
                    isStacked: true,
                    showLegend: true,
                    colors: extractColors(data, colorsPerClass)
                });

                graphUtil.extendDataSerie(dailyNumberOfUsersPerClassChart, dataset, {
                    dataLabels: {
                        format: '{point.y}'
                    }
                });

                dailyNumberOfUsersPerClassChart.reflow();
            });

        TripDashboardFactory.getDailyUserSpreadPercentagePerClass(tripIds)
            .then(function (data) {

                data = data.data;
                var dataset = extractDailyDataset(data, function (value) {
                    return nocUtil.roundTo(value.dbValue * 100, 2);
                }, replaceClassIdWithName);

                var dailyNumberOfUsersPerClassPercentageChart = createDashboardColumnChart({
                    divId: 'daily-user-spread-per-class-percentage-chart',
                    title: $translate.instant('I18N_DASHBOARD.CHART_DAILY_PERCENT_USERS_PER_CLASS'),
                    categories: Array.from(extractCategories(data)), legend: {
                        unitBeforeText: $translate.instant("I18N_DASHBOARD.CLASS") + ' '
                    }, isStacked: true, showLegend: true, colors: extractColors(data, colorsPerClass)
                });

                graphUtil.extendDataSerie(dailyNumberOfUsersPerClassPercentageChart, dataset, getSingleSeriesDataLabelValue('%'));

                dailyNumberOfUsersPerClassPercentageChart.reflow();
            });

        TripDashboardFactory.getDailyAvgConsumptionPerClass(tripIds)
            .then(function (data) {

                data = data.data;

                if (arrayUtil.isEmpty(data)) {
                    return;
                }
                var dataset = extractDailyDataset(data, function (value) {
                    return nocUtil.roundTo((value.dbValue / (thousand24 * thousand24)), 2);
                }, replaceClassIdWithName);

                var dailyAverageConsumptionPerClassChart = createLineChart({
                    divId: 'daily-avg-consumption-per-class-chart',
                    title: $translate.instant('I18N_DASHBOARD.CHART_DAILY_CONSUMPTION_PER_CLASS'),
                    tooltip: {
                        tooltip: {
                            pointFormat: '<b>' + $translate.instant("I18N_DASHBOARD.CLASS") + '</b> {series.name}: {point.y}<br/>',
                            shared: true
                        }
                    },
                    categories: Array.from(extractCategories(data)),
                    legend: { unitBeforeText: $translate.instant("I18N_DASHBOARD.CLASS") + ' ' },
                    colors: extractColors(data, colorsPerClass)
                });

                graphUtil.extendDataSerie(dailyAverageConsumptionPerClassChart, dataset, getSingleSeriesDataLabelValue('MB'));

                dailyAverageConsumptionPerClassChart.reflow();
            });
    }

    function getTileData(tripIds) {

        TripDashboardFactory.getDashboardTiles(tripIds).then(function (data) {
            data = data.data;
            var dashboard = {};
            dashboard.activeTrips = data.numberOfTrips;
            dashboard.averageThroughput = data.averageThroughput;
            dashboard.uniqueUsers = data.uniqueUsers;
            dashboard.portalUsers = data.portalUsers;
            dashboard.exceedPercentage = data.exceedPercentage;
            dashboard.internetAvailability = data.internetAvailability;
            dashboard.portalAvailability = data.portalAvailability;
            dashboard.obisTotalMmcLifeSign = data.obisTotalMmcLifeSign;
            dashboard.obisTotalMmdLifeSign = data.obisTotalMmdLifeSign;
            dashboard.obisTotalPsuLifeSign = data.obisTotalPsuLifeSign;
            dashboard.obisGlobalStatusOk = data.obisGlobalStatusOk;
            dashboard.obisContentOk = data.obisContentOk;
            dashboard.obisMmdBacklight = data.obisMmdBacklight;

            $scope.hideChartsPerClass = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideDataPerClassCharts : false;
            $scope.hidePortalUserTile = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHidePortalUsersTile : false;
            $scope.hideUserExceedTile = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideExceedTile : false;
            $scope.hideBackboneAvailability = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideBackboneAvailability : false;
            $scope.hideQoEChart = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideQoEChart : false;

            $scope.hideTrainGroundConnectivity = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideTrainGroundConnectivity : false;
            $scope.hideConsumptionPerOperatorPieChart = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideConsumptionPerOperatorPieChart : false;
            $scope.hideDailyNumberOfUsersChart = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideDailyNumberOfUsersChart : false;
            $scope.hideTrainGrid = util.isDefined(data.dashboardConfiguration) ? !data.dashboardConfiguration.showSLaGrid : true;
            $scope.isDashboardHideObis = (data && data.dashboardConfiguration) ? (data.dashboardConfiguration.dashboardHideObis === undefined ? true : data.dashboardConfiguration.dashboardHideObis) : true;
            $scope.hideSpectrumBandUsage = util.isDefined(data.dashboardConfiguration) ? data.dashboardConfiguration.dashboardHideSpectrumBandUsageChart : true;


            $scope.dashboard = dashboard;

            portalServiceClasses = data.portalServiceClassNames;

            //init map that binds color to class
            portalServiceClasses.forEach(function (serviceClass) {
                getColorPerKey(serviceClass.dbKey, colorsPerClass);
            });

            //create a few more statically defined charts
            createChartsStructure();

            createPerOperatorCharts(tripIds);

            if (!$scope.hideSpectrumBandUsage) {
                createSpectrumUsageCharts(tripIds);
            }


            if (!$scope.hideChartsPerClass) {
                createPerClassCharts(tripIds);
            }

            if (!$scope.hideQoEChart) {
                createQoEChart(tripIds);
            }

            createTripsPerTrainBarChart(data.tripCountPerTrain);
            createDailyUniqueUsersBarChart(data.uniqueUsersPerDay);

            if (!arrayUtil.isEmpty(data.dashboardConfiguration.dashboardSlaIds)) {
                createSLACharts(tripIds, data.dashboardConfiguration);
            }
            if (util.isTrue(data.dashboardConfiguration.showSLaGrid)) {
                showTrainGrid(tripIds);
            }

            vm.statTiles = [{
                title: "ACTIVE_TRIPS",
                tooltip: "RECORDED_TRIPS_AMOUNT",
                color: 'success',
                icon: 'train',
                value: dashboard.activeTrips
            }]
        }
        );
    }

    function createTripsPerTrainBarChart(tripCountPerTrain) {
        $scope.emptyTripNumberCount = false;

        tripCountPerTrain.sort(function (a, b) {
            return arrayUtil.sortNumericByPropertyName("dbKey", a, b);
        });

        console.log(tripCountPerTrain)
        var categories = [];
        new Set(util.getListOfProperties(tripCountPerTrain, 'dbKey')).forEach(function (officialId) {
            categories.push(officialId);
        });

        console.log(categories)

        var values = [];
        tripCountPerTrain.forEach(function (value) {
            values.push(value.dbValue);
        });

        console.log(values);

        var data = {
            'data': values
        };

        var tripNumberChart = createDashboardColumnChart({
            divId: 'trip-number-chart',
            title: $translate.instant('I18N_DASHBOARD.CHART_TOTAL_TRIPS_PER_TRAIN'),
            yTitle: $translate.instant('I18N_DASHBOARD.CHART_TOTAL_TRIPS_PER_TRAIN_YAXIS'),
            categories: categories,
            dataset: [data],
            isStacked: false,
            showLegend: false
        });

        tripNumberChart.reflow();
    }

    function createDailyUniqueUsersBarChart(dailyUsers) {

        var categories = [];

        var dataset = [];
        dailyUsers.forEach(function (userPerDay) {
            var day = $filter('date')(userPerDay.timestamp, 'dd-MM-yyyy');
            dataset.push([day, userPerDay.dbValue]);
            categories.push(day);
        });

        dailyTotalUsersChart.xAxis[0].categories = categories;
        dailyTotalUsersChart.addSeries({
            name: $translate.instant("I18N_DASHBOARD.USERS"),
            data: dataset
        });

        $scope.emptyDailyTotalUsers = false;

        dailyTotalUsersChart.reflow();
    }

    function createSLACharts(tripIds, dashboardConfig) {

        var promises = [];

        var getDailySlaAveragePromise = TripDashboardFactory.getDailySlaValues(tripIds);

        var getAverageperTrainPromise = TripDashboardFactory.getAverageSlasPerTrain(tripIds);

        promises.push(getDailySlaAveragePromise, getAverageperTrainPromise);

        $q.all(promises).then(function (data) {


            var divIdPrefix = 'daily-sla';
            var allowedSLAs = dashboardConfig.dashboardSlaIds;
            $scope.slaCharts = [];

            createGraphDivPerSla(divIdPrefix, allowedSLAs, $scope.slaCharts);

            $scope.renderSlaChart = true;

            $timeout(function () {
                plotMultipleSlaLineChart(data[0].data, allowedSLAs, (divIdPrefix + '-global-'));
                plotMultipleSlaBarChart(data[1].data, allowedSLAs, (divIdPrefix + '-train-'));
            }, 2000);

        });
    }

    function convertKeyValueToDataSet(dbKeyValues, formatValueFn, formatKeyFn) {
        var dataset = [];
        dbKeyValues.forEach(function (entry) {
            var value = !util.isDefined(formatValueFn) ? entry.dbValue : formatValueFn(entry.dbValue);
            var key = !util.isDefined(formatKeyFn) ? entry.dbKey : formatKeyFn(entry);
            dataset.push({ name: key, y: value });
        });
        return dataset;
    }

    /**
     * Extracts 'categories' from a dbKey,dbValue,timestamp object.
     * By default extracts timestamp.
     * @param values
     * @param getValueFn
     * @returns {Set}
     */
    function extractCategories(values, getValueFn) {
        var categories = new Set();
        values.forEach(function (v) {
            categories.add(!util.isDefined(getValueFn) ? $filter('date')(v.timestamp, 'dd-MM-yyyy') : getValueFn(v));
        });

        var isDate = categories.size > 0 && categories.values().next().value.split("-").length === 3;

        if (isDate) {
            categories = Array.from(categories).sort(function (a, b) {
                var aD = moment(a, "DD-MM-YYYY").toDate();
                var bD = moment(b, "DD-MM-YYYY").toDate();
                return arrayUtil.sortDate(aD, bD);
            });
        }
        return categories;
    }

    function extractDailyDataset(values, formatValueFn, formatKeyFn, categoryMatchFn, getCategoryFn, ignoreEmptyValue, isQoEChart) {
        var categories = extractCategories(values, getCategoryFn);

        var dataset = [];
        values.forEach(function (v) {

            var categoryValues = new Map();
            categories.forEach(function (category) {
                categoryValues.set(category, []);
            });

            var holder = {
                'name': util.isDefined(formatKeyFn) ? formatKeyFn(v) : v.dbKey,
                'data': [],
                'key': v.dbKey,
                'categoryValues': categoryValues
            };

            var existing = arrayUtil.getFirstInList(dataset, "name", holder.name);

            if (existing !== undefined) {
                holder = existing;
            } else {
                dataset.push(holder);
            }

            var wantedCategoryValue = util.isDefined(getCategoryFn) ? getCategoryFn(v) : $filter('date')(v.timestamp, 'dd-MM-yyyy');
            if (util.isDefined(holder.categoryValues.get(wantedCategoryValue))) {
                holder.categoryValues.get(wantedCategoryValue).push(v);
            }
        });

        ignoreEmptyValue = util.isDefined(ignoreEmptyValue) ? ignoreEmptyValue : false;
        dataset.forEach(function (holder) {
            holder.categoryValues.forEach(function (value) {
                if (arrayUtil.isEmpty(value)) {
                    if (!ignoreEmptyValue) {
                        holder.data.push(0);
                    }
                } else {
                    if (isQoEChart) {
                        value.forEach(function (vs) {
                            holder.data.push(!util.isDefined(formatValueFn) ? vs.dbValue : formatValueFn(vs));
                        });
                    } else {
                        /** adding values of the same category for the same day */
                        var totalValue = value.reduce((acc, val) => acc + val.dbValue, 0);
                        holder.data.push(!util.isDefined(formatValueFn) ? totalValue : formatValueFn({ dbValue : totalValue }));
                    }
                }
            });
        });

        return dataset;
    }

    function convertMbits(mbitConsumption) {

        if (!util.isDefined(mbitConsumption)) {
            return {
                'value': 0,
                'unit': "MB"
            };
        }

        var mbConsumption = mbitConsumption / 8;
        var length = mbConsumption;

        var gigabyte = thousand;
        var terabyte = gigabyte * thousand;

        var unit = "MB";
        var value = mbConsumption;

        if (length >= gigabyte) {
            if (length >= terabyte) {
                unit = " TB";
                value = mbConsumption / terabyte;
            } else {
                unit = " GB";
                value = mbConsumption / gigabyte;
            }
        }

        var output = $filter('number')(value, 2);

        return {
            'value': output,
            'unit': unit
        }
    }

    function createDashboardColumnChart(options) {
        // function createDashboardColumnChart(div, title, yTitle, credits, tooltip, categories, dataset, legendUnitBefore, legendUnitAfter, isStacked, showLegend, colors, max) {

        var stackPlotOptions = {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    format: "{point.y:,.1f}"
                }
            },
            series: {
                dataLabels: {
                    enabled: true,
                    format: "{point.y:,.1f}"
                }
            }
        };

        var nonStackPlotOptions = {
            column: {
                dataLabels: {
                    enabled: true,
                    format: "{point.y}"
                }
            },
            series: {
                dataLabels: {
                    enabled: true,
                    format: "{point.y}"
                }
            }
        };

        var noLegend = {
            enabled: false
        };

        var xAxis = {
            categories: options.categories
        };

        if (util.isDefined(options.minMax)) {
            xAxis.max = options.minMax.max;
        }

        if (util.isDefined(options.legend) && !util.isDefined(options.legend.unitBeforeText)) {
            options.legend.unitBeforeText = '';
        }

        if (util.isDefined(options.legend) && !util.isDefined(options.legend.unitAfterText)) {
            options.legend.unitAfterText = '';
        }

        if (!util.isDefined(options.legend)) {
            options.legend = {
                unitBeforeText: '',
                unitAfterText: ''
            }
        }

        var legend = {
            labelFormat: options.legend.unitBeforeText + '{name}' + options.legend.unitAfterText,
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom'
        };

        if (!util.isDefined(options.credits)) {
            options.credits = credits;
        }

        if (!util.isDefined(options.tooltip)) {
            options.tooltip = getToolTip();
        }

        return new Highcharts.Chart($.extend({
            chart: {
                renderTo: options.divId,
                type: 'column',
                borderColor: '#ddd',
                borderWidth: 1
            },
            colors: !util.isDefined(options.colors) ? Highcharts.getOptions().colors : options.colors,
            plotOptions: util.isTrue(options.isStacked) ? stackPlotOptions : nonStackPlotOptions,
            yAxis: {
                title: {
                    text: options.yTitle
                }
            },
            xAxis: xAxis,
            stackLabels: {
                enabled: true
            },
            legend: util.isTrue(options.showLegend) ? legend : noLegend,
            title: {
                useHTML: true,
                text: options.title
            },
            series: options.dataset
        }, options.credits, options.tooltip));

    }

    function createLineChart(options) {
        // function createLineChart(div, title, yTitle, credits, tooltip, categories, dataset, legendUnitBefore, legendUnitAfter, colors, xAxisType, plots, minMax, hideLegend) {

        var xAxis = {};
        if (util.isDefined(options.xAxisType)) {
            xAxis.type = options.xAxisType;
        }

        if (util.isDefined(options.categories)) {
            xAxis.categories = options.categories;
        }

        var plotOptions = {
            series: {
                dataLabels: {
                    enabled: true,
                    format: "{point.y:,.1f}"
                }
            }
        };

        var configuredMin = util.isDefined(options.minMax) ? options.minMax.min : undefined;
        var configuredMax = util.isDefined(options.minMax) ? options.minMax.max : undefined;

        options.plotLines = util.isDefined(options.plotLines) ? options.plotLines : [];

        if (util.isDefined(options.legend) && !util.isDefined(options.legend.unitAfterText)) {
            options.legend.unitAfterText = '';
        }

        if (util.isDefined(options.legend) && !util.isDefined(options.legend.unitBeforeText)) {
            options.legend.unitBeforeText = '';
        }

        if (!util.isDefined(options.credits)) {
            options.credits = credits;
        }

        if (!util.isDefined(options.yTitle)) {
            options.yTitle = '';
        }

        if (!util.isDefined(options.dataset)) {
            options.dataset = [];
        }

        var yAxisLegend = util.isTrue(options.hideLegend) ? {
            enabled: false
        } : {
                labelFormat: options.legend.unitBeforeText + '{name}' + options.legend.unitAfterText,
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
            };

        return new Highcharts.Chart($.extend({
            chart: {
                renderTo: options.divId,
                type: 'line',
                borderColor: '#ddd',
                borderWidth: 1
            },
            colors: !util.isDefined(options.colors) ? Highcharts.getOptions().colors : options.colors,
            plotOptions: plotOptions,
            xAxis: xAxis,
            yAxis: {
                title: {
                    text: options.yTitle
                },
                plotLines: options.plotLines,
                min: configuredMin,
                max: configuredMax
            },
            title: {
                text: options.title,
                useHTML: true
            },
            legend: yAxisLegend,
            series: options.dataset
        }, options.credits, options.tooltip));
    }

    function createPieChart(options) {

        var defaultColors = ['#7cb5ec', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
            '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'];

        return new Highcharts.Chart($.extend({
            chart: {
                renderTo: options.div,
                type: 'pie',
                borderColor: '#ddd',
                borderWidth: 1
            },
            colors: util.isDefined(options.colors) ? options.colors : defaultColors,
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>',
                        showInLegend: true,
                        style: {
                            color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                        }
                    }
                }
            },
            title: {
                text: options.title
            },
            subtitle: {
                text: options.subtitle
            }
        }, options.credits, options.tooltip));
    }

    function createChartsStructure() {

        consumptionPerOperatorChart = createPieChart({
            div: 'consumption-per-operator-chart',
            title: $translate.instant("I18N_DASHBOARD.CHART_CONSUMPTION_PER_OPERATOR"),
            subtitle: $translate.instant("I18N_DASHBOARD.CHART_CONSUMPTION_PER_OPERATOR_DESC"),
            credits: credits,
            tooltip: getToolTip()
        });

        if (!$scope.hideChartsPerClass) {

            fairUseExceedPerClassChart = createPieChart({
                div: 'fair-use-exceed-per-class-chart',
                title: $translate.instant("I18N_DASHBOARD.CHART_DAILY_FAIR_USE_EXCEED_PER_CLASS"),
                subtitle: $translate.instant("I18N_DASHBOARD.CHART_DAILY_FAIR_USE_EXCEED_PER_CLASS_DESC"),
                credits: credits,
                tooltip: getToolTip()
            });

            userSpreadPerClassChart = createPieChart({
                div: 'user-spread-per-class-chart',
                title: $translate.instant("I18N_DASHBOARD.CHART_DAILY_USER_SPREAD_PER_CLASS"),
                subtitle: $translate.instant("I18N_DASHBOARD.CHART_DAILY_USER_SPREAD_PER_CLASS_DESC"),
                credits: credits,
                tooltip: getToolTip()
            });

            avgConsumptionPerClassChart = createPieChart({
                div: 'avg-consumption-per-class-chart',
                title: $translate.instant("I18N_DASHBOARD.CHART_AVG_CONSUMPTION_PER_CLASS"),
                subtitle: $translate.instant("I18N_DASHBOARD.CHART_AVG_CONSUMPTION_PER_CLASS_DESC"),
                credits: credits,
                tooltip: getToolTip()
            });
        }

        dailyTotalUsersChart = new Highcharts.Chart($.extend({
            chart: {
                renderTo: 'avg-hourly-users-chart',
                type: 'column',
                borderColor: '#ddd',
                borderWidth: 1

            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
                enabled: false
            },
            title: {
                text: $translate.instant("I18N_DASHBOARD.CHART_TOTAL_INTERNET_USERS_PER_DAY")
            },
            yAxis: {
                title: {
                    text: $translate.instant("I18N_DASHBOARD.USERS")
                }
            },
            xAxis: [{
                type: "category",
                labels: {
                    format: "{value}",
                    rotation: -45
                }
            }]
        }, credits, null, getToolTip()));
    }

    function getDataLabelPercentageAndValue(unit) {
        return {
            dataLabels: {
                format: '<b>{point.name}</b>: {point.percentage:.1f} % <br>{point.y}' + unit + '</br>'
            }
        };
    }

    function getPointDataLabelValue(unit) {
        return {
            dataLabels: {
                format: '<b>{point.name}</b>: {point.y} ' + unit
            }
        };
    }

    function getToolTip(unit, name) {
        var seriesName = '{series.name}: ';
        if (util.isDefined(name)) {
            seriesName = name;
        }
        return {
            tooltip: {
                pointFormat: seriesName + '<b>{point.y} ' + (util.isDefined(unit) ? unit : '') + '</b><br/>',
                shared: true
            }
        }
    }

    function getSingleSeriesDataLabelValue(unit, before) {
        var format = '{point.y:,.2f} ' + unit;
        if (before) {
            format = unit + ' {point.y:,.2f}'
        }
        return {
            dataLabels: {
                format: format
            }
        };
    }

    function getQoESqiName(entry) {
        switch (entry.dbKey) {
            //1500,1501: bytes.
            case "1500":
                return $translate.instant("I18N_DASHBOARD.CHART_DAILY_QOS_USER_KBPS_90");
            case "1501":
                return $translate.instant("I18N_DASHBOARD.CHART_DAILY_QOS_USER_KBPS");
            case "1502":
                return $translate.instant("I18N_DASHBOARD.CHART_DAILY_QOS_GOOGLE_90");
            case "1503":
                return $translate.instant("I18N_DASHBOARD.CHART_DAILY_QOS_GOOGLE");
            case "208":
                return $translate.instant("I18N_DASHBOARD.CHART_DAILY_QOS_LATENCY");
        }
    }

    function formatQoESqiValue(entry) {
        //1500,1501: bytes.
        var value = 0;
        switch (entry.dbKey) {
            case "1500":
            case "1501":
                //bytes
                value = nocUtil.roundTo((entry.dbValue / thousand24 * 8), 1);
                break;
            case "1502":
            case "1503":
                value = entry.dbValue;
                break;
            default:
                value = entry.dbValue;
        }
        return value;
    }

    function getQoEAxisNumber(entry) {
        var value = 0;
        switch (entry) {
            case "1500":
            case "1501":
                value = 0;
                break;
            case "1502":
            case "1503":
                value = 1;
                break;
            case "208":
                value = 2;
                break;
            default:
                value = 0;
        }
        return value;
    }

    function getQoEAxisColor(entry) {
        var value = 0;
        switch (entry) {
            case "1500":
            case "1501":
                value = Highcharts.getOptions().colors[2];
                break;
            case "1502":
            case "1503":
                value = Highcharts.getOptions().colors[0];
                break;
            case "208":
                value = Highcharts.getOptions().colors[1];
                break;
            default:
                value = Highcharts.getOptions().colors[3];
        }
        return value;
    }

    function replaceClassIdWithName(key) {
        var portalClass = arrayUtil.getFirstInList(portalServiceClasses, "dbKey", "" + key.dbKey);
        if (!util.isDefined(portalClass)) {
            return $translate.instant("I18N_DASHBOARD.NOT_CONFIGURED");
        }
        return portalClass.dbValue;
    }

    function replaceClassNameById(key) {
        var portalClass = arrayUtil.getFirstInList(portalServiceClasses, "dbValue", "" + key.dbKey);
        if (!util.isDefined(portalClass)) {
            return $translate.instant("I18N_DASHBOARD.NOT_CONFIGURED");
        }
        return portalClass.dbKey;
    }

    function createGraphDivPerSla(divPrefix, allowedSLAs, scopedSlaCharts) {

        allowedSLAs.forEach(function (sla) {
            var divIdGlobalLineChart = divPrefix + '-global-' + sla;
            var divIdAveragePerTrainBarChart = divPrefix + '-train-' + sla;

            scopedSlaCharts.push({
                "divId": divIdGlobalLineChart
            }, {
                    "divId": divIdAveragePerTrainBarChart
                });
        });

    }

    function addPlotLinesThatEndUpInLegend(chart, sla, amountOfCategories) {
        //fake plot lines that nicely show up in legend.
        //weird position indicator to put second dot ( 2 dots make a line ), seems to be index of category ( categories.length -1 )
        chart.addSeries({
            name: 'Threshold: ' + sla.threshold,
            color: 'red',
            type: 'line',
            lineWidth: 2,
            data: [[0, sla.threshold], {
                x: amountOfCategories,
                y: sla.threshold,
                dataLabels: { enabled: true }
            }]
        });

        chart.addSeries({
            name: 'Target: ' + sla.target,
            color: 'blue',
            type: 'line',
            lineWidth: 2,
            data: [[0, sla.target], {
                x: amountOfCategories,
                y: sla.target,
                dataLabels: { enabled: true }
            }]
        });
    }

    function determineMinMaxForSerie(sla) {
        var minMax = undefined;
        if (util.containsText(sla.unit, "%")) {
            minMax = {
                min: 0,
                max: 100
            }
        } else if (util.containsText(sla.unit, "s")) {
            minMax = {
                min: 0,
                max: sla.threshold
            }
        }
        return minMax;
    }

    function plotMultipleSlaBarChart(data, allowedSLAs, divPrefix) {

        var dataPerTrainMap = util.mapKeyValues(data, 'dbKey', function (key) {
            return arrayUtil.inList(allowedSLAs, Number(key));
        });

        dataPerTrainMap.forEach(function (trainSlaValues, key) {

            var divId = divPrefix + key;

            trainSlaValues.sort(function (a, b) {
                return arrayUtil.sortNumericByPropertyName("dbValue2", a, b);
            });

            var categories = [];
            new Set(util.getListOfProperties(trainSlaValues, 'dbValue2')).forEach(function (trainId) {
                categories.push('Train ' + trainId);
            });

            var values = [];
            trainSlaValues.forEach(function (value) {
                values.push(nocUtil.roundToTwo(value.dbValue1));
            });

            var data = {
                'data': values
            };

            var tripNumberChart = createDashboardColumnChart({
                divId: divId,
                title: $translate.instant('I18N_DASHBOARD.CHART_DAILY_QOS_INDICATORS'),
                yTitle: '',
                tooltip: getToolTip(undefined, ''),
                categories: categories,
                dataset: [data],
                isStacked: false,
                showLegend: false
            });

            tripNumberChart.reflow();

        });
    }

    function plotMultipleSlaLineChart(data, allowedSLAs, divPrefix) {

        var categories = Array.from(extractCategories(data));

        var dailyPerSqiMap = util.mapKeyValues(data, 'dbKey', function (key) {
            return arrayUtil.inList(allowedSLAs, Number(key));
        });

        dailyPerSqiMap.forEach(function (value, key) {

            var dataset = extractDailyDataset(value, function (value) {
                return nocUtil.roundToTwo(value.dbValue);
            }, function (value) {
                return value.name;
            });


            var sla = arrayUtil.isNotEmptyArray(value) ? {
                threshold: value[0].threshold,
                target: value[0].target,
                id: key,
                name: value[0].name,
                unit: value[0].unit
            } : undefined;


            var chart = createLineChart({
                divId: divPrefix + key,
                title: sla.name,
                tooltip: getToolTip(sla.unit),
                categories: categories,
                legend: {
                    unitAfterText: sla.unit
                },
                colors: ['green'],
                minMax: determineMinMaxForSerie(sla)
            });

            graphUtil.extendDataSerie(chart, dataset, getSingleSeriesDataLabelValue(''));

            addPlotLinesThatEndUpInLegend(chart, sla, categories.length - 1);

            chart.reflow();
        });
    }
}];
